export const nanofindLogoNamed =
  "https://static.igem.wiki/teams/4380/wiki/logos/nanofind-logo-named.svg"

export const navigationLogoBig =
  "https://static.igem.wiki/teams/4380/wiki/logos/nav-logo.svg"

export const navigationItemArrow =
  "https://static.igem.wiki/teams/4380/wiki/navigation/navigation-item-arrow.svg"

export const hamburger =
  "https://static.igem.wiki/teams/4380/wiki/navigation/hamburger.svg"
